import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { InquiryApi } from 'api';
import type { Inquiry } from 'api/methods/InquiryApi';

/**
 * [Inquiry] Query Key 생성
 * --
 */
export const inquiryQueryKeys = createQueryKeys('inquiry', {
  getInquiry: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getInquiries: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Inquiry] 문의 전체 조회
 * --
 */
export const useGetInquiries = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: inquiryQueryKeys.getInquiries(params).queryKey,
    queryFn: () => InquiryApi.getInquiries(params),
    ...options,
  });

  return data;
};

/**
 * [Inquiry] 문의 상세 조회
 * --
 */
export const useGetInquiry = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: inquiryQueryKeys.getInquiry(idx, params).queryKey,
    queryFn: () => InquiryApi.getInquiry(idx, params),
  });

  return data;
};

/**
 * [Inquiry] 문의 생성
 * --
 */
export const useCreateInquiry = (body: Inquiry) => {
  const { mutateAsync: createInquiry, ...result } = useMutation({
    mutationFn: (variables: Inquiry) => InquiryApi.createInquiry(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createInquiry, ...result };
};

/**
 * [Inquiry] 문의 수정
 * --
 */
export const useUpdateInquiry = (body: Inquiry) => {
  const { mutateAsync: updateInquiry, ...result } = useMutation({
    mutationFn: (variables: Inquiry) => InquiryApi.createInquiry(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateInquiry, ...result };
};

/**
 * [Inquiry] 문의 삭제
 * --
 */
export const useDeleteInquiry = (idx: number) => {
  const { mutateAsync: deleteInquiry, ...result } = useMutation({
    mutationFn: (variables: number) => InquiryApi.deleteInquiry(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteInquiry, ...result };
};
